import { CUSTOM_TIMINGS_KEY } from './dataDogRUMConstants';
import {
  getObjectFromLocalStorage,
  setObjectInLocalStorage,
  updateObjectInLocalStorage,
} from './localStorageWrapper';

// timedEvents should be an object described in dataDogRUMConstants.js
// custom timing object should be set in top most component of view
export const setCustomTimingObject = timedEvents =>
  setObjectInLocalStorage(CUSTOM_TIMINGS_KEY, timedEvents);

export const checkShouldTrackEventTiming = key => {
  const timedEvents = getObjectFromLocalStorage(CUSTOM_TIMINGS_KEY);
  // Return false if timedEvents is null or doesn't have the key
  return timedEvents && timedEvents[key] === true;
};

const updateEventTimed = event =>
  updateObjectInLocalStorage(CUSTOM_TIMINGS_KEY, event);

// Key should be a valid key described in the timedEvents object
export const trackCustomTimingEvent = key => {
  if (checkShouldTrackEventTiming(key)) {
    window.DD_RUM.onReady(() => {
      window.DD_RUM.addTiming(key, Date.now());
    });

    // Update the key to false so that measurement is only captured once
    updateEventTimed({ [key]: false });
  }
};
